import * as net from 'util/Net';

interface ConfirmMfaSetupResponse {
  success: boolean;
  // Present only in the forced-enrollment sign-in flow: where to send the user once enrolled and
  // signed in (honors the original next_url from SSO/OAuth). Absent for self-service setup.
  redirectUrl?: string;
}

interface VerifyMfaCodeResponse {
  redirectUrl: string;
}

export function confirmMfaSetup(code: string): Promise<ConfirmMfaSetupResponse> {
  return net.postJSONPromise({url: '/settings/mfa', data: {code}});
}

export function verifyMfaCode(code: string): Promise<VerifyMfaCodeResponse> {
  return net.postJSONPromise({url: '/signin/verify-mfa', data: {code}});
}

export function resetMfaEnrollment(userApiId: string): Promise<void> {
  return net.postPromise({url: `/1/api/users/${userApiId}:reset-mfa`});
}

export function disableMfa(): Promise<{success: boolean}> {
  return net.postPromise({url: '/settings/mfa:disable'});
}
